import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      userLoaded: 'user/userLoaded',
      userAvailable: 'user/available',
      userName: 'user/name',
      avatar: 'user/avatar',
      merchantId: 'merchant/merchantId',
    }),
  },
  mounted() {
    if (!this.userLoaded) {
      this.fetchUser();
    }
  },
  methods: {
    ...mapActions({
      fetchUser: 'user/fetchUser',
      changeAvailability: 'user/changeAvailability',
    }),
    changeUserAvailability(state) {
      const data = {
        state,
        merchantId: this.merchantId,
      };
      this.changeAvailability(data);
    },
  },
};
